import { HtmlConnected as Html } from '../html'

export const SignupUnopened = () => <Html name="signup-unopened" />
